module.exports = __webpack_public_path__ + "img/menu_demand.69e4e47d.svg";